export default __webpack_public_path__ + "static/media/wordpress.5b38d840.svg";